import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import { decorator } from '../components/RichEditor/utils';

// Sérialisation générique des entités du store pour le réseau.
// Les EditorState DraftJS sont les seules valeurs non-JSON du store : on les
// remplace récursivement par un marqueur { __collabDraftRaw } à l'envoi, et
// inversement à la réception. Symétrique par construction — couvre boxes,
// masks (boxes imbriquées), triggers (result), defaultValue, labels de
// checkboxs/options, et toute future forme, sans connaissance par type.
const DRAFT_MARKER = '__collabDraftRaw';

export const serializeEntity = (value) => {
  if (value instanceof EditorState) {
    return { [DRAFT_MARKER]: convertToRaw(value.getCurrentContent()) };
  }
  if (Array.isArray(value)) return value.map(serializeEntity);
  if (value && typeof value === 'object') {
    const out = {};
    Object.keys(value).forEach((key) => {
      out[key] = serializeEntity(value[key]);
    });
    return out;
  }
  return value;
};

export const deserializeEntity = (value) => {
  if (Array.isArray(value)) return value.map(deserializeEntity);
  if (value && typeof value === 'object') {
    if (value[DRAFT_MARKER]) {
      return EditorState.createWithContent(
        convertFromRaw(value[DRAFT_MARKER]),
        decorator
      );
    }
    const out = {};
    Object.keys(value).forEach((key) => {
      out[key] = deserializeEntity(value[key]);
    });
    return out;
  }
  return value;
};
